import { Form, Input } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../../../scopedStorage";

const AuthenticateModal = ({
  handleCloseAuthenticate,
  showAuthenticate,
  handleShowSuccess,
  getTransaction,
  getWalletBalance
}) => {
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const collectionsDetails = JSON.parse(localStorage.getItem("collections"));
  const amt = JSON.parse(localStorage.getItem("amounts"));
  const fundCollections = () => {
    setLoading(true);
    const token = storage.getItem("token");
    let payload = {
      password: pass,
      collection_center_id: collectionsDetails.id,
      amount: amt,
    };
    console.log(payload);
    axios
      .post(
        `${switchEndpoint}/aggregation-center/fund-collection-center`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        getWalletBalance();
        getTransaction();
        setLoading(false);
        handleCloseAuthenticate();
        handleShowSuccess();
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  return (
    <div>
      <Modal
        show={showAuthenticate}
        onHide={handleCloseAuthenticate}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-left ml-3">
            <div className="mb-2">
              <div className="text-center mt-3 mb-5">
                <h5 className="sec-headers mb-3">Authenticate Transaction</h5>

                <div className="text-left w-50 m-auto">
                  <label className="label-control mb-0 labelStyle">
                    Enter Password
                  </label>
                  <Form>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                      ]}
                      value={pass}
                      onChange={(e) => setPass(e.target.value)}
                    >
                      <Input.Password placeholder="*************" />
                    </Form.Item>
                  </Form>
                </div>

                <div className="mt-1 mb-5 w-btn m-auto pt-3">
                  <button
                    type="button"
                    className="btn loginBtn btn-sm btn-block d-flex justify-content-center align-items-center"
                    onClick={() => {
                      if (!pass) {
                        toast.error("Enter password", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          pauseOnHover: true,
                          progress: undefined,
                          theme: "light",
                        });
                      } else {
                        fundCollections();
                      }
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <span>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </span>
                    ) : (
                      "Authenticate Transaction"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AuthenticateModal;
